import { type NavLinkProps } from '@fastnorth/kraken/components/navigation';
import useAwardsLink from './navigation-links/useAwardsLink.tsx';
import useHomeLink from './navigation-links/useHomeLink.tsx';
import useLeaderboardLink from './navigation-links/useLeaderboardLink.tsx';
import useFollowingLink from './navigation-links/useFollowingLink.tsx';
import usePhotosLink from './navigation-links/usePhotosLink.tsx';
import useStatisticsLink from './navigation-links/useStatisticsLink.tsx';

const useNavigationLinks = (): NavLinkProps[] => {
  const homeLink = useHomeLink();
  const awardsLink = useAwardsLink();
  const leaderboardLink = useLeaderboardLink();
  const followingLink = useFollowingLink();
  const photosLink = usePhotosLink();
  const statisticsLink = useStatisticsLink();

  // Generate links from definitions
  return [homeLink, leaderboardLink, followingLink, photosLink, awardsLink, statisticsLink].filter(
    (link) => !!link
  );
};

export default useNavigationLinks;
